module.exports = {"TXTWCL_Your_bet_slip_is_empty":{"id":"TXTWCL_Your_bet_slip_is_empty","defaultMessage":"Tu hoja de apuestas está vacía"}}